// extracted by mini-css-extract-plugin
export default {"textContainer":"businessItCaseStudy_textContainer__MJDHy","overlay":"businessItCaseStudy_overlay__YQAFW","heading":"businessItCaseStudy_heading__QGQ3c"};